import React, { FC } from 'react';
import { Code } from 'common/components/Code';

interface IComponentProps {
  code?: string;
}

export const BuyerCode: FC<IComponentProps> = ({ code }) => {
  if (!code) {
    return null;
  }

  return (
    <span className="text-nowrap">
      <span className="mr-2 ff-regular fs-xs color-dark-grey">Артикул клиента:</span>

      <Code buyerCode={code} />
    </span>
  );
};
